import styles from './style.module.scss';
import { PageHeader } from 'components';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';
import useChooseCompany from '../useChooseCompany';

const ChooseCompanyPage = () => {
  const { t } = useTranslation();

  const { columns, data, loading, onChangeTableFilter } =
    useChooseCompany(true);

  return (
    <div>
      <PageHeader title={t('MYPRIORITY').toUpperCase()} />
      <div className={styles.container}>
        <Table
          columns={columns}
          dataSource={data.companies}
          pagination={{
            pageSize: 10000,
            position: ['bottomCenter'],
            hideOnSinglePage: true,
            showSizeChanger: false,
          }}
          onChange={onChangeTableFilter}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default ChooseCompanyPage;
